module.exports = __webpack_public_path__ + "images/share_icon_twitter.3511cb08.png";